<ac-toolbar
    [allowDrag]="false"
    class="toolbar"
    [ngClass]="{ 'toolbar-help-active': toolbarHelpActive }"
>
    <!-- <ac-toolbar-button [iconUrl]="'assets/icons/home-icon.svg'" (onClick)="goHome()">
  </ac-toolbar-button>
  <ac-toolbar-button [iconUrl]="'assets/icons/select.svg'"
                     (onClick)="zoomToRectangle()">
  </ac-toolbar-button>
  <ac-toolbar-button [iconUrl]="'assets/icons/plus.svg'" (onClick)="zoomIn()">
  </ac-toolbar-button>
  <ac-toolbar-button [iconUrl]="'assets/icons/minus.svg'" (onClick)="zoomOut()">
  </ac-toolbar-button>
  <ac-toolbar-button [iconUrl]="'assets/icons/rectangle.svg'" (onClick)="drawRectangle()">
  </ac-toolbar-button>
  <ac-toolbar-button [iconUrl]="'assets/icons/polygon.png'" (onClick)="drawPolygon()">
  </ac-toolbar-button>
  <ac-toolbar-button [iconUrl]="'assets/icons/eraser.svg'" (onClick)="removeAll()">
  </ac-toolbar-button>
  <ac-toolbar-button [iconUrl]="'assets/icons/question.svg'" (onClick)="toggleHelp()">
  </ac-toolbar-button> -->

    <!-- <div class="toolbar-help-panel" [ngClass]="{'active': toolbarHelpActive}">
    this is help!
  </div> -->

    <div class="toolbar-button-group">
        <div
            class="button-container fullscreen"
            (click)="toggleFullScreen()"
            [ngClass]="{ active: fullScreen }"
            appHelpContent
            [(helpContent)]="helpContent.fullScreen"
        >
            <img
                src="assets/icons/fullscreen-expand.svg"
                *ngIf="!fullScreen"
                class="icon"
            />
            <img
                src="assets/icons/fullscreen-collapse.svg"
                *ngIf="fullScreen"
                class="icon"
            />
        </div>
    </div>
    <div class="toolbar-button-group">
        <div
            class="button-container"
            (click)="goHome()"
            appHelpContent
            [(helpContent)]="helpContent.home"
        >
            <img src="assets/icons/home-icon.svg" class="icon" />
        </div>
        <div
            class="button-container"
            (click)="zoomIn()"
            appHelpContent
            [(helpContent)]="helpContent.zoomIn"
        >
            <img src="assets/icons/plus.svg" class="icon" />
        </div>
        <div
            class="button-container"
            (click)="zoomOut()"
            appHelpContent
            [(helpContent)]="helpContent.zoomOut"
        >
            <img src="assets/icons/minus.svg" class="icon" />
        </div>
        <div
            class="button-container"
            [ngClass]="{ disabled: !showBoundaryToggle }"
            (click)="toggleBoundary()"
            appHelpContent
            [(helpContent)]="helpContent.areaType"
        >
            <img
                src="assets/icons/eye-disabled.svg"
                *ngIf="!showBoundaryToggle && !showBoundary"
                class="icon"
            />
            <img
                src="assets/icons/eye.svg"
                *ngIf="showBoundaryToggle && !showBoundary"
                class="icon"
            />
            <img
                src="assets/icons/eye-off.svg"
                *ngIf="showBoundaryToggle && showBoundary"
                class="icon"
            />
        </div>
    </div>
    <div class="toolbar-button-group">
        <div
            class="button-container"
            [ngClass]="{ active: drawingRectangle }"
            (click)="drawRectangle()"
            appHelpContent
            [(helpContent)]="helpContent.drawRectangle"
        >
            <img src="assets/icons/rectangle.svg" class="icon" />
        </div>
        <div
            class="button-container"
            [ngClass]="{ active: drawingPolygon }"
            (click)="drawPolygon()"
            appHelpContent
            [(helpContent)]="helpContent.drawPolygon"
        >
            <img src="assets/icons/polygon.svg" class="icon" />
        </div>
        <div
            class="button-container"
            (click)="removeAll()"
            appHelpContent
            [(helpContent)]="helpContent.removeAll"
        >
            <img src="assets/icons/eraser.svg" class="icon" />
        </div>
    </div>

    <rectangles-editor></rectangles-editor>
    <polygons-editor></polygons-editor>
    <points-editor></points-editor>
</ac-toolbar>
